/* Faza: open every product page on something buyable, in the shopper's own size.
   Size source: localStorage fz_size (written by the quiz) or ?fz_size=L on a link (the email buttons carry it).
   1. If the page opened on a colour that is sold out, switch to the first colour that is not.
   2. Pre-select the shopper's size (on the blazer and the trouser row of a suit).
   Runs on page load only. Never overrides ?colour= or a choice the shopper has already clicked.
   Works on the current product template (.fzv4-*) and the earlier one (.fz-sz). */
(function () {
  'use strict';
  var KEY = 'fz_size', OK = ['S', 'M', 'L', 'XL', '2XL'];
  function norm(v) { v = String(v || '').toUpperCase().replace(/\s/g, ''); return v === 'XXL' ? '2XL' : v; }
  function read() { try { return norm(localStorage.getItem(KEY)); } catch (e) { return ''; } }
  function write(v) { try { localStorage.setItem(KEY, v); } catch (e) { } }

  var m = location.search.match(/[?&]fz_size=([^&#]+)/);
  if (m) { var q = norm(decodeURIComponent(m[1])); if (OK.indexOf(q) > -1) write(q); }

  var size = read();
  if (OK.indexOf(size) < 0) size = '';
  var explicitColour = /[?&]colou?r=/.test(location.search);

  var touched = false;
  document.addEventListener('click', function (e) { if (e.isTrusted) touched = true; }, true);

  function isOn(l) { return l.classList.contains('on'); }
  function isGone(l) { return l.classList.contains('gone'); }
  function click(l) { if (l && !touched) { l.click(); } }
  function labels(row) { return Array.prototype.slice.call(row.querySelectorAll('label[data-value]')); }
  function byValue(row, v) { return labels(row).filter(function (l) { return l.getAttribute('data-value') === v; })[0]; }

  /* current product template */
  function applyV4() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.fzv4-sizes'));
    if (!rows.length) return false;
    var colRow = rows.filter(function (r) { return r.classList.contains('sw'); })[0];
    var sizeRows = rows.filter(function (r) { return !r.classList.contains('sw'); });
    var mySize = size;
    function sizeOk() {
      if (!mySize) return true;
      return sizeRows.every(function (r) { var l = byValue(r, mySize); return !l || !isGone(l); });
    }
    /* 1. a sold-out colour: move to the first colour that can be bought, preferring one that has the shopper's size */
    if (colRow && !explicitColour) {
      var cols = labels(colRow), cur = cols.filter(isOn)[0];
      if (!cur || isGone(cur)) {
        var open = cols.filter(function (l) { return !isGone(l); });
        var pick = null;
        for (var i = 0; i < open.length && !pick; i++) {
          click(open[i]);
          if (sizeOk()) pick = open[i];
        }
        if (!pick && open.length) { click(open[0]); }
      }
    }
    /* 2. the shopper's size */
    if (mySize) {
      sizeRows.forEach(function (r) {
        var l = byValue(r, mySize);
        if (l && !isOn(l) && !isGone(l)) click(l);
      });
    }
    return true;
  }

  /* earlier product template */
  function applyOld() {
    if (!size) return;
    Array.prototype.forEach.call(document.querySelectorAll('[id^="faza-pdp-"]'), function (root) {
      var rows = root.querySelectorAll('.fz-sizebar-row');
      if (rows.length) {
        Array.prototype.forEach.call(rows, function (row) {
          if (!/size/i.test(row.getAttribute('data-fz-option-name') || '')) return;
          var b = row.querySelector('.fz-sz[data-fz-value="' + size + '"]');
          if (b && !isOn(b) && !b.disabled) click(b);
        });
      } else {
        var b2 = root.querySelector('.fz-sz[data-size="' + size + '"]');
        if (b2 && !isOn(b2) && !b2.disabled) click(b2);
      }
    });
  }

  function apply() { if (!applyV4()) applyOld(); }
  function run() { setTimeout(apply, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(apply, 250); });
})();
